module.exports = __webpack_public_path__ + "static/img/ysgj.67f9143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userVal/ysgj.png
// module id = ikBt
// module chunks = 0